export const getStoreAddress = (selectedStore) => {
  const {
    storeAddress: { address1 = '', city = '', stateProvince = '', postalCode = '' },
  } = selectedStore;

  const address = [address1, city].filter(Boolean).join(', ');
  const stateAndPostal = [stateProvince, postalCode].filter(Boolean).join(' ');

  return [address, stateAndPostal].filter(Boolean).join(', ');
};
